<template>
    <div class="page-tabs-box">
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="音乐风格" name="1" link="/system/musicStyleLabel"></el-tab-pane>
            <el-tab-pane label="活动类型" name="2" link="/system/styleLabel"></el-tab-pane>
            <el-tab-pane label="场地类型" name="4" link="/system/siteLabel"></el-tab-pane>
			<el-tab-pane label="周边" name="3" link="/system/goodsLabel"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>